import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            authUrl:null,
            clientId: null, 
            redirectUrl: null, 
            connectedYoutubeAccounts: [], 
            authBaseUrl: "https://accounts.google.com/o/oauth2/auth?scope=https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/userinfo.profile&redirect_uri="
        }
    },
    getters,
    actions,
    mutations
}